import React, { useEffect, useState } from 'react';
import { Box, Breadcrumbs, Card, CardContent, CardHeader, Fab, IconButton, Link, ListItemAvatar, ListItemText, MenuItem, TextField, Tooltip, Typography } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import { mdiPlus, mdiPencil, mdiDelete, mdiContentSave } from '@mdi/js';
import DialogEnsaio from './dialog';
import { DraggableList, MdiIcon, WaitDialog } from '@components';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { reorder } from '../../../util';
import { useModal } from 'mui-modal-provider';
import { v4 } from 'uuid';
const DetailsRelatorioEnsaio = ({ $state, ListaRelatorioService, UIService }) => {
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);
    const [editing, setEditing] = useState(false);
    const [pontos, setPontos] = useState([]);
    const { showModal } = useModal();
    // Detalhes
    const validationSchema = yup.object({
        codigo: yup.string().required('O campo é obrigatório'),
        obrigatorio: yup.number().required('O campo é obrigatório'),
        designacao: yup.string().required('O campo é obrigatório'),
        observacoes: yup.string().nullable()
    });
    const formik = useFormik({
        initialValues: data,
        enableReinitialize: true,
        validateOnMount: false,
        onSubmit: async (values) => {
            const o = await ListaRelatorioService.saveEnsaio($state.params.id, {
                codigo: values.codigo,
                designacao: values.designacao,
                obrigatorio: values.obrigatorio,
            });
        },
        validationSchema
    });
    const fetchData = async () => {
        setLoading(true);
        try {
            const aux = await ListaRelatorioService.findEnsaio($state.params.id);
            setEditing(aux.CoreListaRelatorio.dataPublicacao == null);
            setEditing(true);
            let o = [];
            aux.Pontos.forEach(r => {
                o.push({
                    ...r,
                    _i: v4()
                });
            });
            setPontos(o);
            formik.resetForm();
            formik.setValues(aux);
            setData(aux);
            setLoading(false);
        }
        catch (e) {
            console.log(e);
        }
    };
    const onDragEnd = ({ destination, source }) => {
        // dropped outside the list
        if (!destination)
            return;
        // Altera ordem
        const newItems = reorder(pontos, source.index, destination.index);
        pontos.forEach((r, i, a) => {
            r.ordem = i + 1;
        });
        setPontos(newItems);
    };
    useEffect(() => {
        if (!loading)
            fetchData();
    }, [$state.params.id]);
    return (<Box>
      <Box sx={{ mt: 2, mb: 2 }}>
        <Typography variant='h5'>{loading ? 'A carregar...' : data && data.designacao}</Typography>
        <Breadcrumbs aria-label='breadcrumb'>
          <Link underline='none' color='inherit'>
            Administração
          </Link>
          <Link underline='hover' onClick={() => $state.go('app.administration.lists.list')} color='text.primary' aria-current='page'>
            Modelo de relatórios
          </Link>
          <Link underline='hover' onClick={() => $state.go('app.administration.lists.view', { id: $state.params.lista })}>
            {$state.params.lista}
          </Link>
          <Link underline='none' color='inherit'>
            Ensaios
          </Link>
        </Breadcrumbs>
      </Box>
      <Box>
        {!loading ? (<Box>
            <Box>
              <Grid container spacing={1}>
                <Grid lg={12} xs={12}>
                  <form>
                    <Card sx={{ mb: 1 }}>
                      <CardHeader title='Detalhes'/>
                      <CardContent>
                        <Grid container spacing={2} sx={{ mb: 1 }}>
                          <Grid lg={2} md={3} xs={6}>
                            <TextField label='Código' name='codigo' InputProps={{
                readOnly: !editing /*  */
            }} fullWidth defaultValue={formik.values?.codigo ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.codigo && Boolean(formik.errors.codigo)} helperText={formik.touched.codigo && formik.errors.codigo}/>
                          </Grid>
                          <Grid lg={2} md={3} xs={6}>
                            <TextField label='Obrigatório' name='obrigatorio' InputProps={{
                readOnly: !editing
            }} fullWidth defaultValue={formik.values?.obrigatorio} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.obrigatorio && Boolean(formik.errors.obrigatorio)} helperText={formik.touched.obrigatorio && formik.errors.obrigatorio} select>
                              <MenuItem value={0}>Não</MenuItem>
                              <MenuItem value={1}>Sim</MenuItem>
                            </TextField>
                          </Grid>
                          <Grid lg={8} md={6} xs={12}>
                            <TextField label='Designação' name='designacao' InputProps={{
                readOnly: !editing
            }} fullWidth defaultValue={formik.values?.designacao ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.designacao && Boolean(formik.errors.designacao)} helperText={formik.touched.designacao && formik.errors.designacao}/>
                          </Grid>
                          <Grid lg={12} md={12} xs={12}>
                            <TextField label='Informação Adicional' InputProps={{
                readOnly: !editing
            }} onChange={(event) => { }} fullWidth value={''}/>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </form>
                </Grid>
              </Grid>
            </Box>
            <Card sx={{ mb: 1 }}>
              <CardHeader title='Pontos de verificação' subheader='Pode alterar a ordem dos pontos, arrastando o item para cima ou para baixo' action={editing && (<Tooltip title='Adicionar novo ponto'>
                      <IconButton onClick={async () => {
                    const wait = showModal(WaitDialog, { title: 'Por favor aguarde...' });
                    wait.destroy();
                    showModal(DialogEnsaio, {
                        initial: {},
                        onClose: (data) => {
                            if (data) {
                                setPontos([
                                    ...pontos,
                                    {
                                        id: 0,
                                        codigo: data.codigo,
                                        designacao: data.designacao,
                                        active: 1,
                                        coreListaRelatorioEnsaioId: $state.params.id,
                                        ordem: pontos.length,
                                        tipo: data.tipo,
                                        formato: data.formato,
                                        _i: v4()
                                    }
                                ]);
                            }
                        }
                    });
                }}>
                        <MdiIcon path={mdiPlus}/>
                      </IconButton>
                    </Tooltip>)}/>

              <DraggableList disabled={!editing} itemKey={'id'} items={pontos.filter(r => r.active == 1)} render={item => {
                return [
                    <ListItemAvatar>
                      <Typography>{item.codigo}</Typography>
                    </ListItemAvatar>,
                    <ListItemText primary={item.designacao} /*  *//>
                ];
            }} action={item => {
                return (editing && (<Box sx={{ display: 'flex' }}>
                        <Tooltip title='Editar ponto'>
                          <IconButton onClick={async () => {
                        const wait = showModal(WaitDialog, { title: 'Por favor aguarde...' });
                        wait.destroy();
                        showModal(DialogEnsaio, {
                            initial: item,
                            onClose: (data) => {
                                if (data) {
                                    item.codigo = data.codigo;
                                    item.designacao = data.designacao;
                                    item.tipo = data.tipo;
                                    item.formato = data.formato;
                                }
                            }
                        });
                    }}>
                            <MdiIcon path={mdiPencil}/>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title='Eliminar ponto'>
                          <IconButton onClick={() => { }}>
                            <MdiIcon path={mdiDelete}/>
                          </IconButton>
                        </Tooltip>
                      </Box>));
            }} onDragEnd={onDragEnd}/>
            </Card>
          </Box>) : undefined}
      </Box>
      {!loading && (<Box sx={{
                position: 'fixed',
                margin: 2,
                bottom: 0,
                right: 0,
                display: 'flex',
                gap: 1
            }}>
          {editing && (<Tooltip title={'Guardar alterações'}>
              <Fab color={'error'} onClick={async () => {
                    if (formik.isValid) {
                        const wait = showModal(WaitDialog, { title: 'Por favor aguarde...' });
                        await formik.submitForm();
                        for (let i = 0; i < pontos.length; i++) {
                            await ListaRelatorioService.saveEnsaioPonto(pontos[i]);
                        }
                        wait.destroy();
                        UIService.addToast('Ensaio atualizado com sucesso');
                        fetchData();
                    }
                    else {
                        UIService.addToast('Corrija os erros apresentados no ecrã');
                    }
                }}>
                <MdiIcon path={mdiContentSave}/>
              </Fab>
            </Tooltip>)}
        </Box>)}
    </Box>);
};
export default DetailsRelatorioEnsaio;
